import styled from 'styled-components'

const VerticalBorders = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  &:before {
    transition: all 0.2s;
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: ${({ width }) => width || '10px'};
    height: calc(100% - 30px);
    transform: translateY(-50%);
    background: ${({ background, theme }) => background || theme.colors.black};
    z-index: 1;
    clip-path: polygon(0 0, 100% 2%, 100% 98%, 0 100%);
  }
  &:after {
    transition: all 0.2s;
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: ${({ width }) => width || '10px'};
    height: calc(100% - 30px);
    transform: translateY(-50%);
    background: ${({ background, theme }) => background || theme.colors.black};
    z-index: 1;
    clip-path: polygon(0 2%, 100% 0%, 100% 100%, 0% 98%);
  }
`
export default VerticalBorders
